<app-history-drawer
    [title]="'Activity: ' + user()?.fullName"
    [exportName]="exportName()"
    layout="saves"
    [events]="feed.events()"
    [loading]="feed.loading()"
    [loadFailed]="feed.loadFailed()"
    [hasMore]="feed.hasMore()"
    [showEmptyMessage]="!rangeError()"
    (loadMore)="feed.loadMore()"
    (retry)="feed.retry()"
    (closed)="close()">

    <form class="row g-2 align-items-start" [formGroup]="rangeForm" (ngSubmit)="onApplyRange()">
        <div class="col-6 col-sm">
            <div class="input-group">
                <div class="form-floating">
                    <input class="form-control" id="activityFrom" formControlName="from"
                           ngbDatepicker #activityFrom="ngbDatepicker" (click)="activityFrom.toggle()">
                    <label for="activityFrom">From</label>
                </div>
                <i class="bi bi-calendar vm-icon input-group-text" (click)="activityFrom.toggle()"></i>
            </div>
            @if (isControlInvalid(rangeForm.controls.from)) {
                <div class="text-danger small mt-1">Enter a valid date.</div>
            }
        </div>
        <div class="col-6 col-sm">
            <div class="input-group">
                <div class="form-floating">
                    <input class="form-control" id="activityTo" formControlName="to"
                           ngbDatepicker #activityTo="ngbDatepicker" (click)="activityTo.toggle()">
                    <label for="activityTo">To</label>
                </div>
                <i class="bi bi-calendar vm-icon input-group-text" (click)="activityTo.toggle()"></i>
            </div>
            @if (isControlInvalid(rangeForm.controls.to)) {
                <div class="text-danger small mt-1">Enter a valid date.</div>
            }
        </div>
        <div class="col-12 col-sm-auto">
            <button type="submit" class="btn btn-outline-primary h-100 py-3" [disabled]="feed.loading()">Apply</button>
        </div>
        @if (rangeForm.hasError('rangeOrder')) {
            <div class="col-12 text-danger small">From must be on or before To.</div>
        }
        @if (rangeError(); as error) {
            <div class="col-12 text-danger small">{{ error }}</div>
        }
    </form>
</app-history-drawer>
